import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../lib/router/withRouter';
import TagGroupEditContainer from '../../containers/tag/TagGroupEditContainer';
import PageTemplate from '../../components/template/PageTemplate';
import { tagActions } from '../../store/modules/tag';
import { TAG_LINK_LIST_MODEL } from '../../store/modules/tag/models';
import { TAG_PAGE_NAME, TAG_GROUP_TYPE } from '../../constants/service/app/tagConstants';

class TagGroupCreate extends Component {
  componentDidMount() {
    this.initiate();
  }

  /**
   * 태그 그룹 데이터 초기화
   */
  initiate = () => {
    const { setData } = this.props;

    setData({
      path: ['tagGroupEdit'],
      value: {
        /**
         *  태그 그룹 정보
         */
        tagGroupInfo: {
          /**
           *  태그 그룹명
           */
          tagGroupName: null,
          /**
           *  태그 그룹명 중복 여부
           */
          isDuplicationTagGroupName: false,
          /**
           *  태그 그룹 타입
           */
          tagGroupType: TAG_GROUP_TYPE.GENERAL,
        },
        /**
         *  태그 그룹에 연결된 아이템
         */
        tagGroupItem: TAG_LINK_LIST_MODEL,
        /**
         *  태그 그룹 수정 가능여부
         */
        editableTagGroup: true,
      },
    });
  };

  render() {
    const { insertTagGroup } = this.props;

    return (
      <PageTemplate pageName={TAG_PAGE_NAME.TAG_GROUP_CREATE}>
        <TagGroupEditContainer onSubmit={insertTagGroup} />
      </PageTemplate>
    );
  }
}

const mapDispatchToProps = {
  setData: tagActions.setData,
  insertTagGroup: tagActions.insertTagGroup,
};

export default connect(null, mapDispatchToProps)(withRouter(TagGroupCreate));
